const validateCustomerIdentifier = (customerIdentifier) => !!(customerIdentifier
    && (customerIdentifier.length !== 6
        && customerIdentifier.length !== 7 && customerIdentifier.length !== 10));

export default validateCustomerIdentifier;
